import React from 'react';
import { EmailIcon, EmailShareButton, FacebookIcon, LinkedinIcon, XIcon } from 'react-share';
import { customerData } from '../../../utilities/CustomerData';

export default function DashboardShareRefund() {
  const shareURL = 'https://setcpros.com'
  const shareText = `I just got my tax credit refund from @setcpros! I'm receiving $${customerData.customerLeadData.leadAmount}, and here's what I'm going to do with it: [insert your plan]. SETC Pros helped me claim these credits and get the money I was owed. If you're self-employed like me, make sure to check them out. #SETCPros #TaxCredits #SelfEmployed #TaxRefund #Giveaway #TaxSeason #GigWorker #Entrepreneur`

  return (
    <div className='w-full shadow-full rounded-xl p-6 bg-white flex flex-col mt-4 space-y-4'>
      <h2 className='font-bold text-[#646464] text-center text-xl'>🎉 Share Your SETC Pros Refund For a Chance to Win $1,000! 🎉</h2>
      <p className='text-sm text-gray-700 leading-relaxed'>
        We want to hear how SETC Pros has helped <strong>YOU</strong>! As a thank you
        for trusting us with your tax credit claim, we're giving you the chance to
        win <strong>$1,000</strong>!
      </p>

      <div className='text-sm text-gray-700'>
        <p className='font-semibold'>How to Enter:</p>
        <ul className='list-disc list-inside ml-4 space-y-1'>
          <li>
            <strong>Download Your Custom Check Graphic:</strong> Head to your
            customer portal and download the personalized SETC Pros check graphic
            with your refund amount.
          </li>
          <li>
            <strong>Post the Image:</strong> Post the custom check graphic on your
            Instagram, Facebook, or X (formerly Twitter). Not sure what to write?
            See the sample template next to the check graphic.
          </li>
          <li>
            <strong>Tag @setcpros:</strong> Make sure to tag <strong>@setcpros</strong>{' '}
            in your post.
          </li>
          <li>
            <strong>One Entry Per Platform:</strong> You can post on up to 3 platforms
            (Instagram, Facebook, or X). That means you have up to 3 chances to win!
          </li>
        </ul>
      </div>

      <div className='text-sm text-gray-700'>
        <p className='font-semibold'>Important Dates:</p>
        <ul className='list-disc list-inside ml-4 space-y-1'>
          <li>
            <strong>Deadline:</strong> All posts must be made by 12:00 PM EST on
            October 15th, 2025.
          </li>
          <li>
            <strong>Winner Announcement:</strong> The winner will be announced on
            October 16th, 2025!
          </li>
        </ul>
      </div>

      <p className='text-center font-bold text-lg text-green-600'>Prize: $1,000 🏆💸</p>
      <div className='w-full flex flex-row items-center gap-4 justify-center pt-2'>
        <button onClick={() => window.innerWidth <= 768 ? window.location.href = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareURL)}&quote=${encodeURIComponent(shareText)}` : window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareURL)}&quote=${encodeURIComponent(shareText)}`)}>
          <FacebookIcon size={40} round />
        </button>

        <button onClick={() => window.innerWidth <= 768 ? window.location.href = `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareURL)}&text=${encodeURIComponent(shareText)}` : window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(shareURL)}&text=${encodeURIComponent(shareText)}`)}>
          <XIcon size={40} round />
        </button>
        <button onClick={() => window.innerWidth <= 768 ? window.location.href = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareURL)}&text=${encodeURIComponent(shareText)}` : window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareURL)}&text=${encodeURIComponent(shareText)}`)} >
          <LinkedinIcon size={40} round />
        </button>
      </div>
    </div>
  )
}